import { styled } from "@mui/material";

const StyledScopeList = styled('div')({
	marginLeft: '-20px',
	marginRight: '-20px',
	marginTop: '20px',
});

export default StyledScopeList;
